import React, { Component } from 'react';
import Inherit from '../../../core/inherit';
import UserController from './user.controller';
import withHooks from '../../../core/withHooks';

import { Card, Layout, Loading } from '../../common';
import { CardsRow, PayPeriodCard, Title } from './elements';
import LedgerTable from '../../ledger/elements/LedgerTable';

class User extends Inherit(UserController, Component) {
    state = { loading: true, user: {}, consumer: {} };

    render() {
        const { loading, user, consumer } = this.state;

        return (
            <Layout user={user} fi={user?.fi?.name}>
                {loading ? (
                    <Loading />
                ) : (
                    <>
                        <Title consumer={consumer} />
                        <CardsRow consumer={consumer} />
                        <PayPeriodCard consumer={consumer} />
                        <Card>
                            <LedgerTable rows={consumer?.ledger} />
                        </Card>
                    </>
                )}
            </Layout>
        );
    }
}

export default withHooks(User);
